import Swiper, {Pagination} from 'swiper';

class FeaturesSplitSlider {
  constructor(element) {
    this.element = element;
    this.swiper = null;
    this.slider = this.element.querySelector('[data-element="slider"]');
    this.navigation = this.element.querySelector('[data-element="navigation"]');
  }

  init() {
    this.swiperInit();
  }

  swiperInit() {
    this.swiper = new Swiper(this.slider, {
      grabCursor: true,
      modules: [Pagination],
      on: {
        afterInit: () => {
          this.slider.classList.add('features-split-slider__slider--has-fade-right');
        },
        slideChange: () => {
          if (this.swiper.isEnd) {
            this.slider.classList.add('features-split-slider__slider--has-fade-left');
            this.slider.classList.remove('features-split-slider__slider--has-fade-right');
          } else {
            this.slider.classList.remove('features-split-slider__slider--has-fade-left');
            this.slider.classList.add('features-split-slider__slider--has-fade-right');
          }
        },
      },
      pagination: {
        bulletActiveClass: 'features-split-slider__nav-item-active',
        bulletClass: 'features-split-slider__nav-item',
        clickable: true,
        el: this.navigation,
        renderBullet: function(index, className) {
          const number = index + 1;
          return '<span class="' + className + '">' + number.toString().padStart(2, 0) + '</span>';
        },
      },
      slidesPerView: 1.5,
      spaceBetween: 50,
    });
  }
}

const featuresSplitSlider = {
  init() {
    const featuresSplitSliderElements = document.querySelectorAll('[data-module="features-split-slider"]');

    if (featuresSplitSliderElements && featuresSplitSliderElements.length) {
      featuresSplitSliderElements.forEach((element) => {
        const featuresSplitSliderElement = new FeaturesSplitSlider(element);
        featuresSplitSliderElement.init();
      });
    }
  },
};

export default featuresSplitSlider;
